import { render, staticRenderFns } from "./KollektionenPage.vue?vue&type=template&id=2571f8c1&"
import script from "./KollektionenPage.vue?vue&type=script&lang=js&"
export * from "./KollektionenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports